import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

interface WelcomeStepProps {
  onNext: () => void;
}

const WelcomeStep = ({ onNext }: WelcomeStepProps) => {
  return (
    <div className="text-center space-y-8">
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="inline-block"
      >
        <div className="w-20 h-20 mx-auto bg-gradient-to-br from-gold/20 to-gold-light/20 rounded-2xl flex items-center justify-center backdrop-blur-sm border border-gold/30">
          <Sparkles className="w-10 h-10 text-gold" />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="space-y-4"
      >
        <h1 className="text-4xl sm:text-5xl font-bold text-foreground leading-tight">
          Turn your Book into Something Incredible...
        </h1>
        <p className="text-lg sm:text-xl text-foreground/80 max-w-xl mx-auto">
          See if you qualify for our High-Ticket AI Partner Program
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
        className="pt-4"
      >
        <Button
          onClick={onNext}
          size="lg"
          className="bg-gradient-to-r from-gold via-gold-light to-gold hover:shadow-[0_0_30px_hsl(var(--gold)/0.45)] text-gold-foreground font-semibold px-8 py-6 text-lg transition-all duration-300 hover:scale-105"
        >
          Start Assessment
        </Button>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="text-sm text-muted-foreground"
      >
        Takes less than 2 minutes
      </motion.p>
    </div>
  );
};

export default WelcomeStep;
